import { Fragment } from 'react';
import { useQuery } from '@apollo/client/react';
import Typography from '@mui/material/Typography';
import Loading from '../loading';
import ErrorMessage from '../error-message';
import NotFound from '../not-found';
import MemberList from './member-list';
import type { Group } from '../../types/Group';
import { groupMembersQuery } from '../../apollo/groups';

type Props = {
  group?: Group;
};

const GroupMembersTab = ({ group: groupProp }: Props) => {
  const { data, loading, error } = useQuery(groupMembersQuery, {
    variables: {
      slug: groupProp.slug
    }
  });
  const group = data?.group;
  if (error) {
    return <ErrorMessage message='An error occurred while loading members.' error={error} compact />;
  }
  if (loading) { return <Loading compact />; }
  if (!group) { return <NotFound compact />; }

  return (
    <Fragment>
      <Typography variant="h2">Members</Typography>
      <MemberList members={group.members} group={group} />
    </Fragment>
  );
};

export default GroupMembersTab;
